var $ = require('jquery');
var Labels = EY.Consultation.Labels;
var Marionette = require('marionette');

var View = Marionette.View.extend({
    events: {
        'click @ui.search': 'search',
        'keypress input[type=text]': 'enter'
    },
    template: '#recordSearchLayout',
    ui: {
        keyword: '#keyword',
        search: '#search'
    },
    enter: function (e) {
        if (e.keyCode === 13) {
            this.search();
        }
    },
    search: function () {
        options = this.options || {};
        var keyword = this.ui.keyword.val().trim().replace(/([&()!}[~"/{*+:.$^\\|?\]])/g, '\\$1');

        if (keyword) {

            options.searchedTopics.reset(options.unFilteredTopics.filter(function (row) {
                return row.get("typeText").toLowerCase().indexOf(keyword.toLowerCase()) !== -1
                    || row.get("subTypeText").toLowerCase().indexOf(keyword.toLowerCase()) !== -1
                    || row.get("subjectText").toLowerCase().indexOf(keyword.toLowerCase()) !== -1;
            }));

            $('#gridSection').find('table td').each(function () {
                if ($(this).text().trim().toLowerCase().indexOf($('#keyword').val().trim().toLowerCase()) > -1) {
                    $(this).addClass("mark");
                }
            });
        } else {
            options.searchedTopics.reset(options.unFilteredTopics.toJSON());
        }

        options.types.findWhere({ selected: true }) && options.types.findWhere({ selected: true }).set("selected", false);
        $('#type').find('select').prop('selectedIndex', 0);

    }
});

module.exports.show = function (options) {
    var region = options.region;
    var layout = new View(options); 
    region.show(layout);

};


// WEBPACK FOOTER //
// ./js/Modules/Record/UI/RecordSearchTopic.js